import { FC } from 'react';

import SunshineTag from 'components/_core/SunshineTag';

import locales from './locales';

interface DirectDebitMandateBadgeProps {
  isRevoked: boolean;
}

const DirectDebitMandateBadge: FC<DirectDebitMandateBadgeProps> = ({
  isRevoked,
}) => {
  const badgeColor = !isRevoked ? 'green' : 'grey';
  const badgeLabel = !isRevoked ? locales.active : locales.suspended;

  return (
    <SunshineTag colorScheme={badgeColor} size="sm">
      {badgeLabel}
    </SunshineTag>
  );
};

export default DirectDebitMandateBadge;
